import Model from "./model";
import ApiIndividualThickness from "../api/model/snapshots/layers/IndividualThickness";

export default class IndividualThickness extends Model {
    left: number;
    top: number;
    right: number;
    bottom: number;

    constructor({ left, top, right, bottom }: ApiIndividualThickness) {
        super();
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }

    override toObject(): ApiIndividualThickness {
        return {
            left: this.left,
            top: this.top,
            right: this.right,
            bottom: this.bottom
        };
    }
}
